const Style = {
    row: 'flex items-center gap-2',

    // The native swatch. `appearance-none` plus the inner-swatch pseudo-element
    // reset is what stops Chrome and Firefox drawing their own chrome around
    // it, so it can sit flush next to a field of the same height.
    swatch: `h-10 w-12 flex-none cursor-pointer appearance-none rounded-md border border-input bg-surface p-1
    [&::-moz-color-swatch]:rounded [&::-moz-color-swatch]:border-none
    [&::-webkit-color-swatch]:rounded [&::-webkit-color-swatch]:border-none
    [&::-webkit-color-swatch-wrapper]:p-0`,

    // The hex field does not need to fill the row — a six-digit value plus the
    // reset button reads better than a full-width box with a gap after it.
    text: 'font-mono !w-36 flex-none uppercase',

    hint: 'text-xs text-text-muted',
    preview: 'pt-1',
};

export default Style;
